import { render, staticRenderFns } from "./rabbit-dictbiz.vue?vue&type=template&id=1a866020&scoped=true"
import script from "./rabbit-dictbiz.vue?vue&type=script&lang=js"
export * from "./rabbit-dictbiz.vue?vue&type=script&lang=js"
import style0 from "./rabbit-dictbiz.vue?vue&type=style&index=0&id=1a866020&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a866020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a866020')) {
      api.createRecord('1a866020', component.options)
    } else {
      api.reload('1a866020', component.options)
    }
    module.hot.accept("./rabbit-dictbiz.vue?vue&type=template&id=1a866020&scoped=true", function () {
      api.rerender('1a866020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/rabbit-dictbiz.vue"
export default component.exports